module.exports = __webpack_public_path__ + "img/8.efcc0a28.png";